import { render, staticRenderFns } from "./SendInvitations.vue?vue&type=template&id=6e1cf20a"
import script from "./SendInvitations.vue?vue&type=script&lang=js"
export * from "./SendInvitations.vue?vue&type=script&lang=js"
import style0 from "./SendInvitations.vue?vue&type=style&index=0&id=6e1cf20a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports